<ion-grid class="ion-no-padding">
  <ion-row>
    <ion-col size="12">
      <ion-label class="panel-header-text ion-margin-bottom" color="dark">
        {{ 'installation_titleInstallersOverview' | translate }}
      </ion-label>
    </ion-col>
  </ion-row>

  <ion-row class="ion-margin-top">
    <ion-col size="12">
      <acl-installation-installer-item
        [installer]="installer()"
        [titleKey]="'installation_firstInstaller'"
        [emptyKey]="'installation_noFirstInstaller'"
        [canDelete]="canDeleteFirstInstaller()"
        [canAdd]="canAddInstaller() && !isCurrentUserInstaller2()"
        [addSlot]="1"
        (deleteInstaller)="deleteFirstInstaller.emit()"
        (addInstaller)="addInstaller.emit($event)"
      ></acl-installation-installer-item>
    </ion-col>
  </ion-row>

  <ion-row class="ion-margin-top">
    <ion-col size="12">
      <acl-installation-installer-item
        [installer]="installer2()"
        [titleKey]="'installation_secondInstaller'"
        [emptyKey]="'installation_noSecondInstaller'"
        [canDelete]="canDeleteSecondInstaller()"
        [canAdd]="canAddSecondInstaller()"
        [addSlot]="2"
        (deleteInstaller)="deleteSecondInstaller.emit()"
        (addInstaller)="addInstaller.emit($event)"
      ></acl-installation-installer-item>
    </ion-col>
  </ion-row>
</ion-grid>
